<template lang="pug">
  include ./../../mixins
  +b.mobile-menu
    +b.header__burger(
      :class="button"
      @click.prevent='toggle'
    )
    +b.menu(:class="drawer")
      +e.overlay(:class="overlay")
      +e.sidebar(:class="sidebar")
        slot(name='navigations')
        +b.menu__template(
          v-if="auth"
        )
          +b.c--hover_common.TEXT-BEMTO(
            :fw="'medium'"
            :lh="'initial'"
            :fs="['1xs']"
            :color="'grey4'"
            :tag="'p'"
            @event="postLogoutCabinetAPI"
          ) Logout
</template>

<script>
import {
  postLogoutCabinetAPI,
} from '@/js/services/cabinet'

import {
  scrollUnlock,
  scrollLock,
} from '@/js/scripts/scroll'

export default {
  name: 'MenuModule',
  data() {
    return {
      /**
       * Menu vision.
       */
      auth: window.isAuthenticated,
      vision: false,
    }
  },
  methods: {
    /**
     * Switch !active state menu.
     */
    toggle() {
      this.vision = !this.vision
      if (!this.vision) {
        scrollUnlock()
      } else {
        scrollLock()
      }
    },
    postLogoutCabinetAPI() {
      return postLogoutCabinetAPI.execute({})
        .then(response => {
          window.location.href = '/'
        })
    }
  },
  computed: {
    /**
     * Handlers that affect the display
     * of the component.
     */
    button() {
      return (this.vision) ?
        'icon--type_menu-close' :
        'icon--type_menu-open'
    },
    drawer() {
      return (this.vision) ?
        'menu--isactive' :
        'menu--inactive'
    },
    overlay() {
      return (this.vision) ?
        'menu__overlay--isactive' :
        'menu__overlay--inactive'
    },
    sidebar() {
      return (this.vision) ?
        'menu__sidebar--isactive' :
        'menu__sidebar--inactive'
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/Modules/MenuModule.vue